module.exports = {
  "country": "BE",
  "artist": "Gustaph",
  "song": "Because of You",
  "year": "2023",
  "place": "7",
  "spotify": "320jqrATpl9762bCQkmLDf"
};